<template>
    <b-modal
        id="modal-change-return method"
        centered
        :title="$t('cdb.subscriptions.return_vehicle')"
        v-model="isVisible"
    >
        <b-form-group :label="$t('cdb.subscriptions.return_vehicle')" v-slot="{ ariaDescribedby }">
            <b-form-radio-group
                id="handover-group"
                v-model="handover"
                :aria-describedby="ariaDescribedby"
                label="foo."
                name="radio-options">
                <b-form-radio v-if="subscription.vehicle.pick_up_option !== 'no_delivery'" value="pickup">
                    {{ $t('cdb.subscriptions.return.pickup') }}
                </b-form-radio>
                <b-form-radio value="self">{{ $t('cdb.subscriptions.return.self') }}</b-form-radio>
            </b-form-radio-group>
        </b-form-group>
        <data-entry-column
            :title="$t('cdb.subscriptions.address')"
            :full-width="true"
            v-if="handover === 'self'">
            <template v-slot:value>
                <p>{{ selfReturnAddressName }}</p>
                <component
                    v-bind:is="getAddressComponent"
                    :address="getWhitelabelAddress"
                ></component>
            </template>
        </data-entry-column>
        <data-entry-column
            v-else
            :title="$t('cdb.subscriptions.address')"
            :full-width="true">
            <template v-slot:action>
                <span
                    class="text-link"
                    @click="openChangePickupAddressModal"
                >{{ $t('cdb.subscriptions.change') }}</span>
            </template>
            <template v-slot:value>
                <component
                    v-bind:is="getAddressComponent"
                    :address="getDeliveryData"
                ></component>
            </template>
        </data-entry-column>
        <div class="row" v-if="error">
            <div class="col-12 text-danger">
                {{ error }}
            </div>
        </div>
        <div class="alert alert-info" v-if="handover === 'pickup' && delivery.costs_unformatted > 0">
            <data-entry-column
                :full-width="true"
                :title="$t('cdb.subscription.return.extraCosts')"
                :value="delivery.result + $t('cdb.cancelSubscription.modal.vat')">
            </data-entry-column>
        </div>
        <div class="alert alert-danger" show v-if="handover === 'pickup' && delivery.costs_unformatted === 0">
            {{ $t('cdb.subscription.return.notPossible') }}
        </div>

        <b-form-checkbox class="pb-1" v-model="tocCheck">
            <p v-html="$t('co.conclusion.confirm.gtc', {agb: $getUrl('content-page', { path: 'agb' })})"></p>
        </b-form-checkbox>
        <b-form-checkbox v-model="privacyCheck">
            <p v-html="$t('co.conclusion.confirm.privacy', {agb: $getUrl('content-page', { path: 'datenschutz' })})"></p>
        </b-form-checkbox>
        <template #modal-footer="{ cancel }">
            <button type="button" class="btn btn-secondary" @click="cancel">{{ $t('cdb.subscriptions.abort') }}</button>
            <button type="button" class="btn btn-danger" @click="submit" :disabled="!isValid">
                {{ $t('cdb.subscriptions.returnMethod.submit') }}
            </button>
        </template>
    </b-modal>
</template>

<script>
import DataEntryColumn from "../atoms/DataEntryColumn.vue";
import {EventBus} from '../../event-bus';
import {BFormRadio, BModal, BFormGroup, BFormRadioGroup, BFormCheckbox, BLink} from 'bootstrap-vue';
import AddressBox from "./AddressBox.vue";

export default {
    name: 'ModalReturnMethod',
    components: {
        BFormRadio,
        BModal,
        BFormCheckbox,
        BFormGroup,
        BFormRadioGroup,
        DataEntryColumn,
        BLink,
        AddressBox
    },
    data() {
        return {
            isVisible: false,
            tocCheck: false,
            privacyCheck: false,
            subscription: {},
            delivery: {},
            error: '',
            handover: 'self',
            dateOptions: {
                year: 'numeric',
                month: 'numeric',
                day: 'numeric'
            }
        }
    },

    mounted() {
        EventBus.$on('init-change-return-method', this.getData);
    },

    methods: {
        getData(data) {
            this.subscription = data.subscription
            this.isVisible = true
            this.getDeliveryCosts()
        },
        async getDeliveryCosts() {
            await this.$axios.post('api/v1/vehicle/delivery_cost', {
                address: this.subscription.delivery_address_data.street + ' ' + this.subscription.delivery_address_data.house_number + ', ' + this.subscription.delivery_address_data.postal_code + ' ' + this.subscription.delivery_address_data.city + ', ' + this.subscription.delivery_address_data.country,
                vehicle_uuid: this.subscription.vehicle_uuid
            }).then((response) => {
                if (response.error) {
                    this.error = this.$t('pds.delivery_cost.error')
                } else {
                    this.delivery = response.data
                }
            })
        },
        async submit() {
            await this.$axios.put('api/v1/checkout/update_subscription', {
                subscription_uuid: this.subscription.uuid,
                return_method: this.handover,
                return_method_pickup_costs: this.handover === 'pickup' ? this.delivery.costs_unformatted : 0.00
            }).then(response => {
                if (response.error) {
                    this.error = this.$t('co.personal_data.error')
                }
                this.isVisible = false
                EventBus.$emit('cdb-reload-subscriptions', null);
            })
        },
        openChangePickupAddressModal() {
            EventBus.$emit('init-change-address', {
                address: this.subscription.delivery_address_data,
                title: 'change_pickup_address'
            });
        },
        selfReturnAddressStreet() {
            if (this.subscription && this.subscription.vehicle && this.subscription.vehicle.first_return_location) {
                return this.subscription.vehicle.first_return_location.street
            } else {
                return this.$root.whitelabel.state.contact.address.street
            }
        },
        selfReturnAddressHouseNr() {
            if (this.subscription && this.subscription.vehicle && this.subscription.vehicle.first_return_location) {
                return this.subscription.vehicle.first_return_location.house_number
            } else {
                return this.$root.whitelabel.state.contact.address.house_nr
            }
        },
        selfReturnAddressPlz() {
            if (this.subscription && this.subscription.vehicle && this.subscription.vehicle.first_return_location) {
                return this.subscription.vehicle.first_return_location.postal_code
            } else {
                return this.$root.whitelabel.state.contact.address.plz
            }
        },
        selfReturnAddressCity() {
            if (this.subscription && this.subscription.vehicle && this.subscription.vehicle.first_return_location) {
                return this.subscription.vehicle.first_return_location.city
            } else {
                return this.$root.whitelabel.state.contact.address.city
            }
        },
        selfReturnAddressState() {
            if(this.subscription && this.subscription.vehicle && this.subscription.vehicle.first_return_location) {
                return this.subscription.vehicle.first_return_location.region
            } else {
                return this.$root.whitelabel.state.contact.address.region
            }
        },
        selfReturnAddressCountry() {
            if (this.subscription && this.subscription.vehicle && this.subscription.vehicle.first_return_location) {
                return this.subscription.vehicle.first_return_location.country
            } else {
                return this.$root.whitelabel.state.contact.address.country
            }
        },
        
    },

    computed: {
        isValid() {
            let handoverCheck = true
            if (this.handover === 'pickup') {
                handoverCheck = this.delivery.costs_unformatted === 0 ? false : true
            }

            return this.privacyCheck && this.tocCheck && !this.isSubmitting && handoverCheck
        },

        getDeliveryData() {
            return this.subscription.delivery_address_data
        },

        selfReturnAddressName() {
            if (this.subscription && this.subscription.vehicle && this.subscription.vehicle.first_return_location) {
                return this.subscription.vehicle.first_return_location.name
            } else {
                return this.$root.whitelabel.state.contact.name
            }
        },

        getWhitelabelAddress() {
            return {
                house_number: this.selfReturnAddressHouseNr(),
                street: this.selfReturnAddressStreet(),
                city: this.selfReturnAddressCity(),
                region: this.selfReturnAddressState(),
                postal_code: this.selfReturnAddressPlz(),
                country: this.selfReturnAddressCountry()
            };
        },

        getAddressComponent() {
            return "address-box";
        },
    },
}
</script>
